/**
 * React Query hooks for Dashboard data
 */

import { useQueries } from '@tanstack/react-query';
import { queryKeys } from './index';
import { metricsService } from '@/services/metricsService';
import { fundService } from '@/services/fundService';

const MAX_RECENT_ACTIVITIES = 5;
// Hook for complete dashboard data using separate endpoints
export function useDashboardData(fundId?: string) {
  const queries = useQueries({
    queries: [
      {
        queryKey: [
          ...queryKeys.metrics.all,
          'activity',
          fundId,
          MAX_RECENT_ACTIVITIES,
        ],
        queryFn: () =>
          metricsService.getRecentActivity(fundId, MAX_RECENT_ACTIVITIES),
        staleTime: 30 * 1000, // 30 seconds - activity data updates frequently
        refetchInterval: 60 * 1000, // Auto-refresh every minute
      },
      {
        queryKey: queryKeys.funds.list(),
        queryFn: () => fundService.getFunds(),
      },
    ],
  });

  const [activityQuery, fundsQuery] = queries;

  return {
    recentActivity: activityQuery.data || [],
    funds: fundsQuery.data || [],
    isLoading: activityQuery.isLoading || fundsQuery.isLoading,
    isError: activityQuery.isError || fundsQuery.isError,
    error: activityQuery.error || fundsQuery.error,
    refetch: async () => {
      await Promise.all([activityQuery.refetch(), fundsQuery.refetch()]);
    },
  };
}
